import apiClient from "../../apiClient";
import { CommonApiResponse } from "../../../Controllers/Types/ApiResponse";
import { baseURL } from "../../ApiConstant";

// get floor finishing list
export const getFSFloorFinishingList = async (fs_feature_id: number) => {
    try {
        const response = await apiClient.get(`/api/fs-floor-finishing-list/${fs_feature_id}`);

        if (response.status === 200) {
            return { status: true, body: response.data };
        } else {
            return { status: false, error: "failed" };
        }
    } catch (error: any) {
        console.error("Error fetching data:", error);

        return {
            status: false,
            error: "An error occurred. Please try again later.",
        };
    }
};

// create FloorFinish
export const fsFloorFinishCreate = async (
    fs_feature_id: number,
    brand_id: number,
    location_id: number,
    type_id: number,
    name: string,
    link: string | null,
    note: string | null,
    image_path: File | null,
    file_list: File[] | null
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;
        const formData = new FormData();

        formData.append("fs_feature_id", String(fs_feature_id));
        formData.append("brand_id", String(brand_id));
        formData.append("location_id", String(location_id));
        formData.append("type_id", String(type_id));
        formData.append("name", name);

        if (link !== null) {
            formData.append("link", link);
        }

        if (note !== null) {
            formData.append("note", note);
        }

        if (image_path !== null) {
            formData.append("image_path", image_path);
        }

        if (file_list !== null) {
            file_list.forEach((file, index) => {
                formData.append("file_list[]", file);
            });
        }

        const response = await fetch(`${baseURL}/api/fs-floor-finishing/create`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: formData,
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Body error",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

// update FloorFinish
export const fsFloorFinishUpdate = async (
    id: number,
    brand_id: number,
    location_id: number,
    type_id: number,
    name: string,
    link: string | null,
    note: string | null,
    image_path: File | null,
    file_list: File[] | null
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;
        const formData = new FormData();

        formData.append("brand_id", String(brand_id));
        formData.append("location_id", String(location_id));
        formData.append("type_id", String(type_id));
        formData.append("name", name);

        if (link !== null) {
            formData.append("link", link);
        }

        if (note !== null) {
            formData.append("note", note);
        }

        if (image_path !== null) {
            formData.append("image_path", image_path);
        }

        if (file_list !== null) {
            file_list.forEach((file, index) => {
                formData.append("file_list[]", file);
            });
        }

        const response = await fetch(`${baseURL}/api/fs-floor-finishing/update/${id}`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: formData,
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Body error",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

// Delete FloorFinish
export const fsFloorFinishDelete = async (
    id: number
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;

        const response = await fetch(
            `${baseURL}/api/fs-floor-finishing/delete/${id}`,
            {
                method: "DELETE",
                headers: {
                    Accept: "application/json",
                    Authorization: FULL_TOKEN,
                },
            }
        );

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Body error",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

// Delete  single file
export const fsFloorFinishFileDelete = async (
    floor_finishing_data_id: number,
    index: number
): Promise<CommonApiResponse> => {
    try {
        // prepare ids for number list
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(`${baseURL}/api/fs-floor-finishing-file/delete`, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: JSON.stringify({ floor_finishing_data_id, index }),
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Body error",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};